// extracted by mini-css-extract-plugin
export default {"rselect":"select_rselect__Y+Mlm","control":"select_control__SZsLk","option":"select_option__5vWN3"};